import React from 'react';

// Styles & Assets
import styles from './PollQuestions.module.css';

// Services
import { sortByAttribute } from '../../../services/sort';

// Interfaces
import { PollQuestion } from '../../../interfaces/Poll';

const PollQuestions: React.FC<{
    questions: PollQuestion[]
}> = ({ questions }) => {


    return <>
        {(sortByAttribute(questions, 'order')).map((question, index) =>
            <div key={question.id} className={styles.questionContainer} data-testid='poll-question-container'>
                <p className={styles.question}>{index + 1}.&nbsp;&nbsp;{question.description} {question.required ? '*' : ''}</p>
                {question.answers && question.answers.length > 0 ?
                    sortByAttribute(question.answers, 'order').map(answer =>
                        <p key={answer.id} className={styles.pollAnswer}>
                            {question.inquiry_question_type_id === 1 ?
                                <span>{answer.description || '-'}</span>
                                :
                                <span>{answer.description || '-'}</span>
                            }
                        </p>
                    )
                    :
                    <p className={styles.pollAnswer}><span>-</span></p>
                }
            </div>
        )}
    </>;

};

export default PollQuestions;